import React from 'react';
import LocaleContext from '../locale/LocaleContext';
import { getDisplayName } from '../../utils/hocHelpers';

export default function withLocale(WrappedComponent) {
  const WithLocale = (props) => (
    <LocaleContext.Consumer>
      {(locale) => <WrappedComponent locale={locale} {...props} />}
    </LocaleContext.Consumer>
  );
  WithLocale.displayName = `WithLocale(${getDisplayName(WrappedComponent)})`;
  return WithLocale;
}
